import { Loader } from "@googlemaps/js-api-loader";

/// <reference types="google.maps" />

const loader = new Loader({
  apiKey: "AIzaSyC3-ueMlWqw1L4L1hVGabSfID7Z8Fg52Z8",
  libraries: ["places"],
});

const initializeMapWithLocation = function (
  input: JQuery<HTMLInputElement>,
  output: JQuery<HTMLElement>,
  mapElement: JQuery<HTMLElement>,
  latLong?: google.maps.LatLng
) {
  let shouldDetectLocation = false;
  if (!latLong || !latLong.lat() || !latLong.lng()) {
    shouldDetectLocation = true;
    // Give a reasonable starting location so we don't end up in the ocean
    latLong = new google.maps.LatLng(39.5092, -98.4337);
  }

  // Create a "Google(r)(tm)" LatLong object representing our DBGeometry's lat/long.
  const position = latLong;

  // Initialize the map widget.
  const map = new google.maps.Map(mapElement[0], {
    zoom: 13,
    center: position,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
  });

  // Place a marker on it, representing the DBGeometry object's position.
  const marker = new google.maps.Marker({
    position,
    map,
  });

  const infoWindow = new google.maps.InfoWindow({
    content: latLong.lat() + ", " + latLong.lng(),
  });

  marker.addListener("click", function () {
    infoWindow.open(map, marker);
  });

  const geocoder = new google.maps.Geocoder();
  const updateMarker = (latLng: google.maps.LatLng, fromInput: boolean) => {
    marker.setPosition(latLng);

    // This new location might be outside the current viewport, especially
    //  if it was manually entered. Pan to center on the new marker location.
    map.panTo(latLng);

    geocoder.geocode({ location: latLng }, function (results, status) {
      // Black magic, courtesy of Hanselman's original version.
      let formattedDisplay = marker.getPosition()?.toUrlValue(13);
      if (status === "OK" && results && results[0]) {
        formattedDisplay =
          results[0].formatted_address + " (" + formattedDisplay + ")";
      }
      if (!fromInput) {
        input.val(formattedDisplay ?? "unknown");
      }
      infoWindow.setContent(formattedDisplay);
    });
    output.val(marker.getPosition()?.toUrlValue(13) ?? "unknown");
  };
  if (shouldDetectLocation && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function (currentLocation) {
        updateMarker(
          new google.maps.LatLng(
            currentLocation.coords.latitude,
            currentLocation.coords.longitude
          ),
          false
        );
      },
      function () {
        // Browser supports GeoLocation but the user likely didn't give permission
        // set fromInput = true so we don't stuff the address of the default location
        // into the input field, which isn't super useful
        map.setZoom(3); // zoom out to entire US
        updateMarker(position, true);
      }
    );
  } else {
    // Force a reverse geocode to happen
    updateMarker(position, false);
  }

  // If the input came from an EditorFor, initialize editing-related events.
  if (input.hasClass("editor-for-dbgeography")) {
    google.maps.event.addListener(
      map,
      "click",
      (args: { latLng: google.maps.LatLng; fromInput: boolean }) =>
        updateMarker(args.latLng, args.fromInput)
    );

    const autocomplete = new google.maps.places.Autocomplete(input[0]);
    autocomplete.addListener("place_changed", function () {
      const place = autocomplete.getPlace()?.geometry?.location;
      if (place) {
        updateMarker(place, true);
      }
    });
    // Bias search results towards the map
    autocomplete.bindTo("bounds", map);

    // Attempt to react to user edits in the input field.
    input.on("change", function () {
      const latLong = parseLatLong(this.value);

      if (latLong != null) {
        updateMarker(latLong, true);
      }
    });
  }
};

const parseLatLong = function (value: string): google.maps.LatLng | undefined {
  const latLong = value.match(/-?\d+\.\d+/g);

  if (latLong) {
    return new google.maps.LatLng(
      parseFloat(latLong[0]),
      parseFloat(latLong[1])
    );
  } else {
    return undefined;
  }
};

$(() => {
  if ($(".location-editor").length > 0) {
    loader.load().then(() => {
      $(".location-editor").each(function () {
        const latLng = $(this).find(".location-data");
        const mapContainer = $(this).find(".location-map-container");
        const map = $(this).find(".location-map");
        const editor = $(this).find(
          ".editor-for-dbgeography"
        ) as JQuery<HTMLInputElement>;

        if (editor.val() != "") {
          initializeMapWithLocation(
            editor,
            latLng,
            map,
            parseLatLong(editor.val() as string)
          );
        } else {
          mapContainer.hide();
          editor.click(function () {
            if (!mapContainer.is(":visible")) {
              mapContainer.show();
              mapContainer.css("display", "inline-block");
              initializeMapWithLocation(
                $(this),
                latLng,
                map,
                parseLatLong(latLng.val() as string)
              );
            }
          });
        }
        editor.on("change", function () {
          if (editor.val() == "") {
            mapContainer.hide();
            map.empty();
          }
        });
      });
    });
  }
});
